import React, { useState } from "react";
import './wishlist.css';
import { useContext,useEffect } from "react";
import wishlistContent from "../wishlistContent/wishlistContent";
import Footer from "../homeComponents/footer";
import cartContext from "../Context/cartContext";
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Wishlist() {
    const { wishlist, setWishlist } = useContext(wishlistContent);
    const {cart,setCart} = useContext(cartContext);
    const [wish,setWish] = useState(JSON.parse(localStorage.getItem('userWishlist')));



    return (<div className="wishlistMain">
        <h1 className="wishlistHeading">My Wishlist</h1>
        <div className="wishlistItem">
        {wish ?   
                wish.map((it,idx) => {
                    // console.log(it);
                    return (
                        <div class="card" key={idx}>
                            <img src={it.image} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title wishlistItemHeading">{it.brand}</h5>
                                {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                <span className="itemOrginalPrice">{it.OriginalPrice ? `Rs. ${it.OriginalPrice}` : ""}</span>
                                <span className="itemOffer">{it.offer ? `(${it.offer}%)` : ""} </span>
                                <h5 className="itemCurrentPrice">Rs.{it.currentPrice} </h5>
                                {/* <a href="#" class="btn btn-primary">Go somewhere</a> */}
                                <button type='button' className='btn btn-outline-dark bagButton wishlistBagButton' onClick={()=>{
                                    var b = wish;
                                    b.splice(idx,1);
                                    if(b.length != 0){
                                    localStorage.setItem('userWishlist',JSON.stringify(b));
                                    setWish(JSON.parse(localStorage.getItem('userWishlist')));
                                    }else{
                                        localStorage.removeItem('userWishlist');
                                        setWish();
                                    }
                                    var c = JSON.parse(localStorage.getItem('userCart'));
                                    if(c){
                                 c.push({image:it.image,id:uuidv4(), brand: it.brand,type : it.type,currentPrice : it.currentPrice,OriginalPrice : it.OriginalPrice,offer:it.offer});
                                    localStorage.setItem('userCart',JSON.stringify(c));
                                    toast.success("You have succesfully added item to cart", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                        });
                                    }else{
                                        localStorage.setItem('userCart',JSON.stringify([{image:it.image,id:uuidv4(), brand: it.brand,type : it.type,currentPrice : it.currentPrice,OriginalPrice : it.OriginalPrice,offer:it.offer}]));  
                                        toast.success("You have succesfully added item to cart", {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "light",
                                            });
                                    }

                                    var a = wishlist;
                                    a.splice(idx,1)
                                    setWishlist(a);
                                    setCart((prev)=>{
                            return [...prev,{image:it.image,id:uuidv4(), brand: it.brand,type : it.type,currentPrice : it.currentPrice,OriginalPrice : it.OriginalPrice,offer:it.offer}];
                        })}}>
                            <i class="fa-solid fa-bag-shopping"></i>  Add To Bag</button>

                            <button type='button' className='btn btn-outline-danger bagButton wishlistBagButton'
                            onClick={()=>{
                                var b = wish;
                                b.splice(idx,1);
                                if(b.length != 0){
                                localStorage.setItem('userWishlist',JSON.stringify(b));
                                setWish(JSON.parse(localStorage.getItem('userWishlist')));
                                }else{
                                    localStorage.removeItem('userWishlist');
                                    setWish();
                                }
                                toast.error("You remove item to wishlist", {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                    });
                            }}
                            >Remove from wishlist</button>
                            </div>
                        </div>
                    )
                })
            :
            <div className="wishlistFlexEmpty">
            <h3 className="wishlistEmpty">Your Wishlist is empty!!</h3>
            <p className="wishlistEmpty">ADD A FEW PRODUCTS AND THEN EXPLORE THE COOLEST WAY TO SHOP CLOTHES ONLINE!</p>
            </div>
    }
        </div>
        <ul className='homeFlex cartSecondFlex' type="none">
                <div>
                    <li className='homeIcon'><i class="fa-solid fa-camera-rotate"></i></li>
                    <li><h4>EASY EXCHANGE</h4></li>
                </div>
                <div>
                    <li className='homeIcon'><i class="fa-solid fa-hand-holding-heart"></i></li>
                    <li><h4>100% HANDPICKED</h4></li>
                </div>
                <div>
                    <li className='homeIcon'><i class="fa-sharp fa-solid fa-circle-check"></i></li>
                    <li><h4>ASSURED QUALITY</h4></li>
                </div>
            </ul>
            <ToastContainer />
        <Footer/>
    </div>
    )
}